import React from "react";
import { localize } from "../../services/localize";

const TagElement = ({
  value,
  onClick = () => {},
  isPrimary = false,
  isMinimal = false,
  isSmall = false,
  isSelected = false,
}) => {
  const iconClass = {
    ORGANISATION_TAG__PEACE: "fa-solid fa-dove dark:text-white",
    ORGANISATION_TAG__CHILDREN: "fa-solid fa-heart text-red-500",
    ORGANISATION_TAG__ENVIRONMENT: "fa-solid fa-seedling text-green-500",
    ORGANISATION_TAG__MENTAL_HEALTH: "fa-solid fa-brain text-yellow-500",
    ORGANISATION_TAG__WOMEN: "fa-solid fa-venus text-pink-500",
    ORGANISATION_TAG__SOCIAL_JUSTICE: "fa-solid fa-balance-scale text-cyan-500",
    ORGANISATION_TAG__FOOD_AND_SHELTER: "fa-solid fa-home text-blue-500",
    ORGANISATION_TAG__MEDICAL_RESEARCH: "fa-solid fa-flask text-purple-500",
    ORGANISATION_TAG__ANIMALS: "fa-solid fa-paw text-orange-200",
    ORGANISATION_TAG__EDUCATION: "fa-solid fa-book text-yellow-500",
  }[value];

  let backgroundColor =
    "dark:bg-color-dark-background-tertiary bg-color-background-secondary";

  let textColor = "dark:text-color-dark-text-primary";

  let borderColor = "dark:border-transparent border-2";

  let textSize = "text-md";
  let iconSize = "text-xl";

  if (isPrimary) {
    backgroundColor = "bg-color-raindrop-primary";
    textColor = "text-color-raindrop-secondary";
  }

  if (isMinimal) {
    borderColor = "border-transparent";
    backgroundColor = "bg-transparent";
    textColor = "text-color-white";
  }

  if (isSmall) {
    textSize = "text-sm";
    iconSize = "text-md";
  }

  if (isSelected) {
    borderColor = "border-2 border-color-raindrop-primary ";
  }

  return (
    <div
      onClick={onClick}
      className={`flex flex-row items-center content-baseline justify-center text-center text-base py-2 gap-2 px-3 rounded-lg  ${borderColor} ${textColor} ${backgroundColor} `}
    >
      <i className={`${iconSize} ${iconClass}`} />
      <div className={`${textSize} font-bold whitespace-nowrap`}>
        {localize(value)}
      </div>
    </div>
  );
};

export default TagElement;
